import React, { useState, useEffect } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { IoMdRadioButtonOff, IoMdRadioButtonOn, IoIosCheckmarkCircleOutline } from "react-icons/io";
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md';

export default function Checkbox({ v, showAllAnswers, student_answer, onChange }) {
    
    const [answers, setanswers] = useState([]); 

    function st_answers(key) {
        if (student_answer) {
            return false;
        }
        
        let ck = answers?.filter(r => r == key);

        if (!ck?.length) {
            setanswers(p => [...p, key]);
        } else {
            setanswers(p => [...p?.filter(r => r != key)]);
        }
    }

    
    useEffect(() => {
        if (!showAllAnswers) {

            let trueAns = [];
            let ckAnswer = [];
            v?.answers?.map((v2, k2) => { 
                if (v2?.true) {
                    trueAns.push(k2)
                }
            });
            
            trueAns.sort();
            answers.sort();

            let right = false;
            if (answers?.join("") == trueAns?.join("")) {
                right = true;
            }

            if (typeof onChange != 'undefined') onChange({ ID: v?.ID, answer: answers, right: right });
        }
    }, [answers]);

    useEffect(() => {

        
        if (showAllAnswers) {
            let arr = [];
            v?.answers?.map((v2, k2) => { 
                if (v2?.true) {
                    arr.push(k2);
                }
            });

            setanswers(arr);
            
        } else {
            if (student_answer) {
                setanswers(student_answer);
            } else {
                setanswers([]);
            }
        }
    }, [showAllAnswers]);
    
    
    
    return (
        <div className='answersBox'>
            {v?.answers?.map((v2, k2) => { 
                

                let ck = v2?.true;

                let checked = false;
                let exists = answers?.filter(r => r == k2);
                if (exists?.length) {
                    checked = true;
                }

                return (
                    <a href='javascript:void(0)' onClick={() => st_answers(k2)} className={checked? "checked" : "none"}>
                        {checked ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />}
                        <span>{v2?.answer}</span>
                    </a>
                );

            })}
        </div>
    );
}